import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import { runBulk } from "routes/schedule/my-schedules/my-custom-schedules/bulk-runner"
import { CustomScheduleActions } from "./selection-actions-slot-definitions"
import { clearRetired, succeeded, retireBatch } from "./selection-actions-helpers"

CustomScheduleActions.plug(<ReinstateRetiredButton if={({ retiredItems = [] }) => retiredItems.length} priority={30} />)

export function ReinstateRetiredButton() {
    const { retiredItems = [] } = useBoundContext()

    return (
        <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="ix:restore" />}
            onClick={restoreRetired}
            data-cy="bulk-restore"
        >
            Reinstate {retiredItems.length}
        </Button>
    )

    async function restoreRetired() {
        const count = retiredItems.length
        const ok = await confirm(
            "These schedules will return to your active list.",
            `Reinstate ${count} retired ${"schedule".pluralize(count)}`,
            undefined,
            "Reinstate",
            { okIcon: "ix:restore", cancelIcon: "mdi:close-circle-outline" }
        )
        if (!ok) return
        const ids = retiredItems.map((m) => m._id)
        const { failed } = await runBulk(ids, { progress: "Reinstating", past: "Reinstated" }, retireBatch(false))
        clearRetired(succeeded(ids, failed))
    }
}
